// Best (all-time) result logged per exercise name, scanning every day's log.
// Comparable metric depends on the log's type: weight for a lift, duration
// for a timed hold/cardio block, rounds for a circuit.
export function getExercisePRs(logs) {
  const prs = {}
  for (const log of Object.values(logs)) {
    const exLogs = log.exerciseLogs || {}
    for (const [name, entry] of Object.entries(exLogs)) {
      const metric = exerciseMetric(entry)
      if (metric == null) continue
      const existing = prs[name]
      if (!existing || metric > existing.metric) {
        prs[name] = { ...entry, metric, dayNumber: log.dayNumber }
      }
    }
  }
  return prs
}

// Every logged value for one exercise across all days, sorted oldest-first -
// for the per-exercise trend chart (PRs above only keep the single best).
export function getExerciseHistory(logs, exerciseName) {
  return Object.values(logs)
    .map((log) => {
      const entry = log.exerciseLogs?.[exerciseName]
      const metric = exerciseMetric(entry)
      if (metric == null) return null
      return { day: log.dayNumber, metric, entry }
    })
    .filter(Boolean)
    .sort((a, b) => a.day - b.day)
}

function exerciseMetric(entry) {
  if (!entry) return null
  const value = entry.type === 'time' ? entry.duration : entry.type === 'rounds' ? entry.rounds : entry.weight
  return Number.isFinite(value) ? value : null
}

// Human-readable label for one logged (or PR) entry, e.g. "40kg x 8",
// "45 sec", "3 rounds". Older entries saved before type-aware logging (just
// {weight, reps}) fall back to the weight-reps format.
export function formatExerciseLog(entry) {
  if (!entry) return ''
  if (entry.type === 'time') return `${entry.duration}${entry.unit === 'sec' ? ' sec' : ' min'}`
  if (entry.type === 'rounds') return `${entry.rounds} round${entry.rounds === 1 ? '' : 's'}`
  return `${entry.weight}kg${entry.reps ? ` × ${entry.reps}` : ''}`
}
